<label *ngIf="props.altLabel" [for]="field.id">{{ props.altLabel }}</label>
<p-dropdown
  [class.bf-contentdropdown-readonly]="props.readonly"
  [filterPlaceholder]="props.filterPlaceholder"
  class="{{ formControl.invalid && formControl.touched ? 'p-invalid' : '' }}"
  [filter]="props.filter"
  [filterBy]="props.filterBy"
  [filterFields]="props.filterFields"
  [optionValue]="props.valueProp"
  [optionLabel]="props.labelProp"
  [virtualScroll]="props.virtualScroll"
  [virtualScrollItemSize]="props.virtualScrollItemSize"
  [options]="props.options"
  [formControl]="formControl"
  [showClear]="props.showClear"
  [formlyAttributes]="field"
  (onChange)="props.change && props.change(field, $event)"
  appendTo="body"
  [id]="field.id"
  [readonly]="props.readonly"
  [placeholder]="props.placeholder"
  (keydown)="props.keydown ?? onKeyDown($event)"
>
  <ng-template let-selectedItem pTemplate="selectedItem">
    <div
      *ngIf="getChain(field.key, model) && selectedItem != undefined"
      class="basin-display-flex basin-align-items-center"
    >
      <img
        *ngIf="props.type === 'image'"
        class="square"
        [src]="
          props.valueProp ? selectedItem[props.valueProp] : selectedItem.value
        "
        alt="props.labelProp ? selectedItem[props.labelProp] : selectedItem.label"
      />
      <div
        *ngIf="props.type != 'image'"
        class="{{ getChain(field.key, model) }}"
        [ngClass]="{
          circle: props.type === 'color',
          square: props.type === 'gradient',
          'content-item': true
        }"
      ></div>
      <div>
        {{
          (props.labelProp
            ? selectedItem[props.labelProp]
            : selectedItem.label) ??
            (props.valueProp
              ? selectedItem[props.valueProp]
              : selectedItem.value)
        }}
      </div>
    </div>
  </ng-template>
  <ng-template let-item pTemplate="item">
    <div class="basin-display-flex basin-align-items-center">
      <img
        *ngIf="props.type === 'image'"
        class="square"
        [src]="props.valueProp ? item[props.valueProp] : item.value"
        alt="item.label"
      />
      <div
        *ngIf="props.type != 'image'"
        class="{{ props.valueProp ? item[props.valueProp] : item.value }}"
        [ngClass]="{
          circle: props.type === 'color',
          square: props.type === 'gradient',
          'content-item': true
        }"
      ></div>
      <div>
        {{
          (props.labelProp ? item[props.labelProp] : item.label) ??
            (props.valueProp ? item[props.valueProp] : item.value)
        }}
      </div>
    </div>
  </ng-template>
</p-dropdown>
<label *ngIf="!props?.label" [for]="field.id">{{ props.placeholder }}</label>
